import { render, staticRenderFns } from "./TermsArticle.vue?vue&type=template&id=69c74960"
var script = {}
import style0 from "./TermsArticle.vue?vue&type=style&index=0&id=69c74960&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports